/*
  HLL visual pass: the product info tab row (Description, Size & Fit, ...).

  The row stays on one line on every product page, phone and desktop. When
  the tabs do not fit it scrolls sideways. The edge where more tabs are
  hiding fades out and shows a small arrow, so it is clear there is more.
  The layout is in section 13 of assets/hll-visual-pass.css. This script:
    1. tells the CSS which side has hidden tabs (data-hll-more on the row)
    2. adds the two arrow buttons, which slide the row along
    3. slides a half-hidden tab fully into view when it is tapped or focused

  The tabs themselves still work through assets/product-info-tabs.js. If
  this script does not run, the row still scrolls, with no fade or arrow.
*/
(function () {
  'use strict';

  var EDGE = 64; // px kept clear of the faded edge when a tab is brought into view

  function update(nav) {
    var max = nav.scrollWidth - nav.clientWidth;
    var x = nav.scrollLeft;
    var more = 'none';
    if (max > 1) more = x <= 1 ? 'right' : x >= max - 1 ? 'left' : 'both';
    if (nav.getAttribute('data-hll-more') !== more) nav.setAttribute('data-hll-more', more);
  }

  function reveal(nav, tab) {
    var row = nav.getBoundingClientRect();
    var box = tab.getBoundingClientRect();
    var shift = 0;
    if (box.right > row.right - EDGE) shift = box.right - (row.right - EDGE);
    else if (box.left < row.left + EDGE) shift = box.left - (row.left + EDGE);
    if (!shift) return;
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    nav.scrollBy({ left: shift, behavior: calm ? 'auto' : 'smooth' });
  }

  function setup(nav) {
    if (nav.getAttribute('data-hll-tabs')) return;
    nav.setAttribute('data-hll-tabs', '1');

    var queued = false;
    nav.addEventListener(
      'scroll',
      function () {
        if (queued) return;
        queued = true;
        window.setTimeout(function () {
          queued = false;
          update(nav);
        }, 60);
      },
      { passive: true }
    );

    function onTab(event) {
      var tab = event.target.closest ? event.target.closest('.product-info-tabs__tab') : null;
      if (tab) reveal(nav, tab);
    }
    nav.addEventListener('click', onTab);
    nav.addEventListener('focusin', onTab);

    // Arrow buttons sit after the row, on top of its faded edge. They are
    // extras for mouse and touch: keyboard and screen reader users reach
    // every tab through the tabs themselves, so the arrows are kept out of
    // the tab order.
    ['prev', 'next'].forEach(function (dir) {
      var arrow = document.createElement('button');
      arrow.type = 'button';
      arrow.className = 'hll-tabs-more hll-tabs-more--' + dir;
      arrow.tabIndex = -1;
      arrow.setAttribute('aria-hidden', 'true');
      arrow.addEventListener('click', function () {
        var step = Math.max(120, nav.clientWidth * 0.7) * (dir === 'next' ? 1 : -1);
        var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        nav.scrollBy({ left: step, behavior: calm ? 'auto' : 'smooth' });
      });
      nav.parentNode.appendChild(arrow);
    });

    update(nav);
  }

  function boot() {
    if (!document.body.classList.contains('template-product')) return;
    var navs = document.querySelectorAll('.product-info-tabs__nav');
    Array.prototype.forEach.call(navs, setup);

    var timer;
    window.addEventListener('resize', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        Array.prototype.forEach.call(navs, update);
      }, 150);
    });
    // Fonts can change the tab widths after the first measure
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        Array.prototype.forEach.call(navs, update);
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
